import {
  Box,
  Button,
  Chip,
  Divider,
  Fab,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tab,
  Typography,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  CircularProgress,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EmailIcon from "@mui/icons-material/Email";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Timeline from "@mui/lab/Timeline";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import icon_time from "../../../../Image/icon_time.png";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Avatar from "@mui/material/Avatar";
import icon_pdf from "../../../../Image/icon_pdf.png";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveIcon from "@mui/icons-material/Remove";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import IconButton from "@mui/material/IconButton";
import ModalPreviewPDF from "../DocumentPersonalComponent/ModalPreviewPDF";
import dayjs from "dayjs";
import "dayjs/locale/th"; // ใช้ภาษาไทย
import buddhistEra from "dayjs/plugin/buddhistEra"; // ใช้พ.ศ.
import {
  PDF_example,
  PDF_example3page,
} from "../DocumentPersonalComponent/Base64";
import RejectSignatureDialog from "./RejectSignatureModal";
import SignModal from "./SignDigitalModal";
import DrawSignatureModal from "./DrawSignatureModal";
import ThirdPendingSignatureModal from "./ThirdPendingSignatureModal";
import {
  APIEndpointWeb,
  GetLocalStorageAccessToken,
  webapi,
} from "../../../../client/web";
import { useHistory, useLocation } from "react-router-dom";
import no_data from "../../../../Image/no_data.png";
import LoadingIndicator from "../PersonalDataAgreementComponent/Loading/LoadingIndicator";
import { PPHOMember } from "./IndexPendingDocument";

dayjs.extend(buddhistEra);
dayjs.locale("th");

interface PdfArray {
  name: string;
  base64: string;
}

interface IPDFFile {
  type: string;
  pdf_base64: string;
  document_json_id: string;
  document_json_name: string;
  pdf_link_download: string;
  file_name: string;
  pdf_link: string;
}

interface Film {
  title: string;
  year: number;
}

interface LocationState {
  message?: string;
  datadetail: any;
  // document_list: any[];
  dataform: any;
}

export interface IResultDetail {
  hoode: string;
  hname: string;
  document_no: string;
  provider_id: string;
  one_id: string;
  cid: string;
  name: string;
  email: string;
  status_user: string;
  priority: string;
  document_list: IResultDetailDocument_list[];
  attachment: null;
  approve_list: IResultDetaiApprove_list;
}

export interface IResultDetailDocument_list {
  type: string;
  pdf_base64: string;
  document_json_id: string;
  document_json_name: string;
  pdf_link_download: string;
}

export interface IResultDetaiApprove_list {
  priority: number;
  provider_id: string;
  one_id: string;
  cid: string;
  prefix: string;
  name: string;
  email: string;
  position: string;
  comment: string;
  status: string;
  update_time: string;
  reason: string;
}

interface IDataresultDetail {
  resultDetail: any;
  loading: boolean;
  valuePdf: any;
  getBase64OfSign: string;
  localStorageData: any;
  localStorageOrganization: any;
  optionsPPHOMember: PPHOMember[];
  setLoading: (value: boolean) => void;
  selectDoc: any;
  checkReject: boolean;
  arrrayOfPdf: any
  getSignatureByProviderTwo: any
}

const top100Films = [
  { title: "The Shawshank Redemptioxxxxxxn", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
];
const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

const DetailDocPending: React.FC<IDataresultDetail> = ({
  resultDetail,
  getSignatureByProviderTwo,
  loading,
  valuePdf,
  getBase64OfSign,
  setLoading,
  localStorageData,
  localStorageOrganization,
  optionsPPHOMember,
  selectDoc,
  checkReject,
  arrrayOfPdf
}) => {
  const [valueTabDetail, setvalueTabDetail] = useState("1");
  const [openPDF, setOpenPDF] = useState<boolean>(false);
  const handleChangeTabDetail = (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    setvalueTabDetail(newValue);
  };
  const dataTest = [1, 2, 3, 4, 5, 6];
  const [dataArrayPDF, setDataArrayPDF] = useState<PdfArray[]>([
    { name: "New1.PDF", base64: PDF_example },
    { name: "NewNara.PDF", base64: PDF_example3page },
  ]);
  const [base64PDF, setBase64PDF] = useState<any>("");
  const [personalCheck, setPersonalCheck] = useState<string>("");
  const [approverAutocomplete, setApproverAutocomplete] =
    useState<PPHOMember | null>(null);
  const [docNumber, setDocNumber] = useState("");
  const [options, setOptions] = useState<Film[]>([]);
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [openSignModal, setOpenSignModal] = useState(false);
  const [hasSignatureFromProvider, setHasSignatureFromProvider] =
    useState(false); // เช็คว่ามีลายเซ็นจาก Provider หรือไม่
  const [openThirdSignatureModal, setOpenThirdSignatureModal] = useState(false);
  const [openFirstDialog, setOpenFirstDialog] = useState(false);
  const [resultComment, setResultComment] = useState<any>([]);
  const [base64OfSign, setBase64OfSign] = useState<string>("");

  const [stringTextInputAutocomplete, setStringTextInputAutocomplete] =
    useState<string>("");

  const [dataArrayPDFV1, setDataArrayPDFV1] = useState<PdfArray[]>([]);

  const location = useLocation<LocationState>();
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  const [state, setState] = useState<LocationState>({
    message: "",
    datadetail: {}, // ป้องกัน undefined
    dataform: {},
  });
    const history = useHistory();

  //   useEffect(() => {
  //     if (!(Object.keys(resultDetail).length === 0 && resultDetail.constructor === Object)) {
  //       console.log("resultDetail xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", resultDetail)
  //     }
  // }, [resultDetail]);

  useEffect(() => {
    if (valueTabDetail === "2") {
      PostComment();
    }
  }, [valueTabDetail]);

  const handleOpenSignModal = () => {
    setOpenSignModal(true);
  };

  const handleCloseSignModal = () => {
    setOpenSignModal(false);
  };
  const handleSign = () => {
    console.log("ลงนามลายเซ็นดิจิทัล");
  };
  // const handleOpenThirdSignatureModal = () => {
  //   setOpenThirdSignatureModal(true);
  // };

  // const handleSignThird = () => {
  //   console.log("ยืนยันการลงนามลำดับที่ 3");
  //   setOpenThirdSignatureModal(false);
  // };
  const handleOpenRejectModal = () => {
    setOpenRejectModal(true);
  };

  const handleEditDoc = () => {
    // const text_params = "padding";
    history.push({
      pathname: "/form-personal-new",
      search: '?page=3',
      state: { resultDetail }, // ส่งค่าไปใน state
    });
    // history.push(`/form-personal-new?text=${encodeURIComponent(text_params)}`);
  };

  

  const handleCloseRejectModal = () => {
    setOpenRejectModal(false);
  };
  const date = "2025-01-28T09:53:00";

  useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
      return;
    }

    setLoadingAutocomplete(true);
    sleep(1000).then(() => {
      setLoadingAutocomplete(false);
      // setOptions(top100Films);
    });
  }, [openAutocomplete]);

  const handleOpen = async (file: IPDFFile) => {
    console.log("file.pdf_base64 :>> ", file);
    setBase64PDF(file.pdf_link);
    await setOpenPDF(true);
  }
  const downloadBase64File = (
    base64Data: string,
    fileName: string,
    fileType: string
  ) => {
    // Convert Base64 to Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], { type: fileType });

    // Create a download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Example Usage
  const handleDownload = () => {
    // downloadBase64File(valuePdf, "example.pdf", "application/pdf");
    const selectedDocument = filterDocumentsBySelection(selectDoc)[0];

    if (selectedDocument?.document_json_name) {
      downloadBase64File(
        valuePdf,
        `${selectedDocument.document_json_name}.pdf`,
        "application/pdf"
      );
    } else {
      console.error("No valid document found for download.");
    }
  };


  const handleDownloadList = (data :IPDFFile) => {
    try {
   var dataBase64Pure = data.pdf_link.replace(/^data:application\/pdf;base64,/,"");
    downloadBase64File(dataBase64Pure,`${data.file_name}.pdf`,"application/pdf")
    } catch (error) {
      console.log(error)
    }
  };
  const handleChangeTest = (event: SelectChangeEvent) => {
    setPersonalCheck(event.target.value);
  };

  const PostComment = async () => {
    try {
      var DataComment = {
        document_no: resultDetail.document_no,
        // document_no: "2025-02-25-00007-00222-dsa",
      };
      var { data } = await webapi.post(
        `${APIEndpointWeb.PostGetComment}`,
        DataComment,

        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setResultComment(data.result ? data.result : []);
    } catch (error) {
      console.log(error);
    }
  };

  const stepStatusMessage = (status: string) => {
    switch (status) {
      case "approved":
        return "เสร็จสิ้น";
      case "waiting":
        return "รออนุมัติ";
      case "reject":
        return "ปฏิเสธ";
      default:
        return "";
    }
  };

  const stepStatusBg = (status: string) => {
    switch (status) {
      case "approved":
        return "#00BA00";
      case "waiting":
        return "#FFC048";
      case "reject":
        return "#d2302e";
      default:
        return "#c8c8c8";
    }
  };

  const checkPriorityButton = (): boolean => {
    try {
      // return true
      if (!(Object.keys(resultDetail).length === 0 && resultDetail.constructor === Object)) {
        if (resultDetail.priority &&resultDetail.approve_list && resultDetail.approve_list.length > 0) {
          // console.log("resultDetail.priority", resultDetail.priority)
          if (resultDetail.priority === "1") {
             return (resultDetail.approve_list[0].status === "waiting" && resultDetail.status_user === "waiting")
          } else {
            var index: number = Number(resultDetail.priority);
            index = index - 1;
            return !(resultDetail.approve_list[index].status === "approved");
          }
      
        } else {
          return true;
        }
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
      return true;
    }
    // }
  };

  const checkPriorityAutocomplete = (index: number): boolean => {
    // return false
    try {
      if (
        resultDetail.approve_list &&
        resultDetail.approve_list.length > 0 &&
        resultDetail.priority === "3" &&
        index === 3
      ) {
        return !(resultDetail.approve_list[2].status === "approved" || resultDetail.approve_list[2].status === "reject" || resultDetail.approve_list[2].status === "");
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
    // }
  };

  // const stepStatusBg = (status: string) => {
  //   switch (status) {
  //     case "approved":
  //       return "#00BA00";
  //     case "waiting":
  //       return "#FFC048";
  //     case "reject":
  //       return "#d2302e";
  //     default:
  //       return "#00BA00";
  //   }
  // };

  const stepStatusIcon = (status: string) => {
    switch (status) {
      case "approved":
        return <CheckCircleIcon sx={{ fontSize: 16, color: "#ffffff" }} />;
      case "waiting":
        return <AccessAlarmIcon sx={{ fontSize: 15, color: "#ffffff" }} />;
      case "reject":
        return <CancelIcon sx={{ fontSize: 16, color: "#ffffff" }} />;
      default:
        return <div>-</div>
    }
  };

  const stepStatusIconFrist = (status: string) => {
    switch (status) {
      case "approved":
        return <CheckCircleIcon color="success" sx={{ fontSize: 20 }} />;
      case "waiting":
        return (
          <img
            src={icon_time}
            alt="icon_time"
            style={{ width: "20px", height: "auto" }}
          />
        );
      case "reject":
        return <CancelIcon color="error" sx={{ fontSize: 20 }} />;
      default:
        return (
          <RemoveIcon
            sx={{
              fontSize: 19,
              color: "ffffff",
              backgroundColor: "#C8C8C8",
              borderRadius: 10,
            }}
          />
        );
    }
  };

  const filterDocumentsBySelection = (selectDoc: string[]) => {
    return resultDetail && resultDetail.document_list
      ? resultDetail.document_list.filter(
        (doc: any) => doc?.type && selectDoc.includes(doc.type)
      )
      : [];
  };

  const formatDateWithBuddhistEra = (date: string) => {
    const formattedDate = dayjs(date)
      .locale("th")
      .format("D MMMM YYYY เวลา HH:mm น.");

    const yearAD = dayjs(date).year();
    const yearBE = yearAD + 543;

    return formattedDate.replace(yearAD.toString(), yearBE.toString());
  };

  const updateTime = resultDetail?.approve_list?.[0]?.update_time;
  const formattedDate = updateTime
    ? formatDateWithBuddhistEra(updateTime)
    : "-";

  return (
    <Grid mt={2}>
      <Grid
        rowSpacing={2}
        container
        sx={{
          backgroundColor: "#f4f9ff",
          padding: "1px 16px 17px 16px",
          border: "2px solid #E8F1FA",
          borderRadius: 2,
        }}
      >
        <Grid item xs={4} md={4}>
          <Typography className="title-detail">ชื่อสถานพยาบาล :</Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography className="box-text">
            {resultDetail.hname ? resultDetail.hname : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4} md={4}>
          <Typography className="title-detail">เลขที่เอกสาร :</Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography className="box-text text-detail-item">
            {filterDocumentsBySelection(selectDoc).length > 0 &&
              filterDocumentsBySelection(selectDoc)[0]?.type === selectDoc
              ? filterDocumentsBySelection(selectDoc)[0]?.document_json_no
              : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4} md={4}>
          <Typography className="title-detail">
            เลขที่เอกสารอ้างอิง :
          </Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography className="box-text text-detail-item">
            {resultDetail.document_no ? resultDetail.document_no : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4} md={4}>
          <Typography className="title-detail">ชื่อไฟล์ :</Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography className="box-text">
            {filterDocumentsBySelection(selectDoc).length > 0 &&
              filterDocumentsBySelection(selectDoc)[0]?.type === selectDoc
              ? filterDocumentsBySelection(selectDoc)[0]?.document_json_name
              : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4} md={4}>
          <Typography className="title-detail">ชื่อผู้ส่ง:</Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography className="box-text">
            {resultDetail?.approve_list && resultDetail?.approve_list[0].name
              ? resultDetail?.approve_list[0].name
              : "-"}
          </Typography>
        </Grid>
        <Grid item xs={4} md={4}>
          <Typography className="title-detail">ส่งเมื่อ:</Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography className="box-text">
            {/* 28 มกราคม 2568 เวลา 09.53 น.//  approve_list[0].update_time */}
            {formattedDate}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ paddingTop: 3 }}>
        <Grid
          container
          xs={12}
          direction="row"
          sx={{
            justifyContent: "flex-end",
            mt: 2,
            mb: 3,
            zIndex: 10,
          }}
        >
           {resultDetail?.status ==="approved"?
          <Fab
            onClick={handleDownload}
            variant="extended"
            size="small"
            color="error"
            sx={{
              border: "2px solid red",
              backgroundColor: "transparent",
              color: "red",
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.1)",
              },
            }}
          >
            <PictureAsPdfIcon sx={{ mr: 1 }} />
            ดาวน์โหลด PDF
          </Fab>:""}
        </Grid>

        {/* <Grid container > */}
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            {valueTabDetail === "1"
              ? "ลำดับการทำงาน"
              : valueTabDetail === "2"
                ? "ความคิดเห็น"
                : "ไฟล์แนบ"}
          </Typography>
          <TabContext value={valueTabDetail}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChangeTabDetail}
                aria-label="lab API tabs example"
              >
                <Tab label="ลำดับการทำงาน" value="1" />
                <Tab label="ความคิดเห็น" value="2" />
                <Tab label="ไฟล์แนบ" value="3" />
              </TabList>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {/* selecttest */}
              {/* <Select
                labelId="personal-check-label"
                value={personalCheck}
                onChange={handleChangeTest}
                displayEmpty
              >
                <MenuItem value="1">ลำดับที่ 1</MenuItem>
                <MenuItem value="2">ลำดับที่ 2 กรณีปฎิเสธ</MenuItem>
                <MenuItem value="3">ลำดับที่ 3</MenuItem>
                <MenuItem value="4">ลำดับที่ 4</MenuItem>
              </Select> */}
              {/* endselecttest */}

              <TabPanel
                value="1"
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: 0,
                }}
              >
                <Grid
                  container
                  sx={{
                    backgroundColor: "#ecf6ff",
                    padding: 2,
                    mt: 2,
                    borderRadius: 2,
                    display: "grid",
                    gridTemplateRows: "1fr",
                    height: "100%",
                    flexGrow: 1,
                  }}
                >
                  <Grid item xs={12} sx={{ height: "100%" }}>
                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0,
                        },
                        padding: 0,
                        height: "100%",
                        flexGrow: 1,
                      }}
                    >
                      {Array.isArray(resultDetail?.approve_list) &&
                        resultDetail.approve_list.length > 0 ? (
                        resultDetail.approve_list.map(
                          (item: IResultDetaiApprove_list, index: number) => (
                            <TimelineItem
                              key={item.priority}
                              sx={{ padding: 0 }}
                            >
                              <TimelineSeparator>
                                <TimelineDot
                                  sx={{ backgroundColor: "#ffffff" }}
                                >
                                  {stepStatusIconFrist(item?.status)}
                                </TimelineDot>
                                {index !== 3 ? <TimelineConnector /> : ""}
                              </TimelineSeparator>
                              <TimelineContent sx={{ padding: 1 }}>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item xs={12} md={9}>
                                    <Typography variant="body2">
                                      {/* {localStorageData?.data?.full_cid? localStorageData.data.full_cid :"-"}
                                      {item.cid} */}
                                      {/* {localStorageData?.data?.full_cid}
                                      {item?.cid} */}
                                      {/* ลำดับที่ {index + 1} :
                                      {item?.name  ?
                                        item?.prefix + item?.name + " " + (localStorageData?.data?.full_cid === item?.cid ? "(คุณ)" : "") :
                                        item?.prefix + item?.name + " "} */}
                                      {/* {item?.name && item?.priority === Number(resultDetail.priority) ? item?.prefix + item?.name + " " + '(คุณ)' : item?.prefix + item?.name}{" "} */}
                                      {/* {localStorageData?.data?.full_cid + " " + item?.cid + " " + resultDetail?.priority + " "}  */}
                                      ลำดับที่ {index + 1} :{" "}
                                      { Number(item?.priority) === 1 ? 
                                      (item?.name && Number(item?.priority) === Number(resultDetail?.priority) && localStorageData?.data?.full_cid === item?.cid ? 
                                      item?.prefix + item?.name + " " + "(คุณ)" : item?.prefix + item?.name)
                                      : Number(item?.priority) === 3 ? 
                                      (item?.name && Number(item?.priority) === Number(resultDetail?.priority) && (localStorageData?.data?.full_cid === item?.cid || (!item?.cid || item?.cid === "")) ? 
                                      item?.prefix + item?.name + " " + "(คุณ)" : item?.prefix + item?.name)
                                      : 
                                      (item?.name && Number(item?.priority) === Number(resultDetail?.priority) ? 
                                      item?.prefix + item?.name + " " + "(คุณ)" : item?.prefix + item?.name) }
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    sx={{ height: "100%" }}
                                  >
                                    <Grid container direction="column">
                                      <Grid
                                        item
                                        sx={{
                                          mt: 2,
                                          justifyContent: "flex-start",
                                          display: "flex",
                                          minWidth: "100%",
                                        }}
                                      >
                                        {!(item?.status === "") ?
                                          <Chip
                                            sx={{
                                              height: "25px",
                                              backgroundColor: stepStatusBg(
                                                item?.status
                                              ),
                                              color: "#ffffff",
                                              "& .MuiChip-icon": {
                                                color: "#ffffff",
                                              },
                                            }}
                                            icon={stepStatusIcon(item?.status)}
                                            label={stepStatusMessage(
                                              item?.status
                                            )}
                                          // color={stepStatusIcon(item?.status)}
                                          /> : <Chip
                                            sx={{ height: "25px", fontSize: 16, color: "#C8C8C8", backgroundColor: '#C8C8C8', paddingLeft: 3, paddingRight: 3 }}
                                            label={<span style={{ color: "#ffffff" }}>-</span>}
                                          />}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item sx={{ width: "100%" }}>
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: "#969696",
                                        textAlign: "right",
                                        display: "block",
                                      }}
                                    >
                                      {item.update_time
                                        ? (() => {
                                            const date = new Date(
                                              item.update_time
                                            );
                                            if (isNaN(date.getTime()))
                                              return "-";

                                            const year = date.getFullYear();
                                            const buddhistYear = year + 543;
                                            const day = date
                                              .getDate()
                                              .toString()
                                              .padStart(2, "0");
                                            const month = (date.getMonth() + 1)
                                              .toString()
                                              .padStart(2, "0");

                                            const hours = date
                                              .getHours()
                                              .toString()
                                              .padStart(2, "0");
                                            const minutes = date
                                              .getMinutes()
                                              .toString()
                                              .padStart(2, "0");
                                            const seconds = date
                                              .getSeconds()
                                              .toString()
                                              .padStart(2, "0");

                                            return `${day}/${month}/${buddhistYear} ${hours}:${minutes}:${seconds}`;
                                          })()
                                        : "-"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                                {/* {approverAutocomplete} */}
                                {/* {String(checkPriorityAutocomplete(index))} */}
                                {checkPriorityAutocomplete(index) ? (
                                  <Autocomplete
                                    sx={{
                                      mt: 2,
                                      width: "100%",
                                      "& .MuiInputBase-root": {
                                        height: "40px",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        borderRadius: "30px",
                                        backgroundColor: "#fff",
                                      },
                                    }}
                                    open={openAutocomplete}
                                    onOpen={() => setOpenAutocomplete(true)}
                                    onClose={() => setOpenAutocomplete(false)}
                                    options={optionsPPHOMember}
                                    getOptionLabel={(option) => option.name}
                                    loadingText="กำลังค้นหา..."
                                    loading={loadingAutocomplete}
                                    inputValue={stringTextInputAutocomplete}
                                    onInputChange={(_, newInputValue) =>
                                      setStringTextInputAutocomplete(
                                        newInputValue
                                      )
                                    }
                                    placeholder="เลือกผู้มีสิทธิ์อนุมัติ"
                                    value={approverAutocomplete}
                                    onChange={(_, newValue) => {
                                      console.log("newValue", newValue);
                                      setApproverAutocomplete(newValue);
                                    }}
                                    noOptionsText={
                                      "ไม่พบข้อมูล"
                                      // approverAutocomplete ? `"${approverAutocomplete}" ไม่พบข้อมูล` : "ไม่มีข้อมูล"
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="เลือกผู้มีสิทธิ์อนุมัติ"
                                        InputProps={{
                                          ...params.InputProps,
                                          sx: {
                                            "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "green", // Default border color
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "darkred", // Hover border color
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor:
                                                "#0288D1 !important", // Focus border color
                                            },
                                          },
                                          endAdornment: (
                                            <>
                                              {loadingAutocomplete ? (
                                                <CircularProgress
                                                  color="inherit"
                                                  size={20}
                                                />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                ) : (
                                  ""
                                )}
                              </TimelineContent>
                            </TimelineItem>
                          )
                        )
                      ) : (
                        <Grid
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            flexDirection: "column",
                          }}
                        >
                          <img
                            src={no_data}
                            alt="no_data"
                            style={{
                              width: 65,
                              height: "auto",
                            }}
                          />
                          <Typography>ไม่มีข้อมูล</Typography>
                        </Grid>
                      )}

                      {/* <TimelineItem>
                        <TimelineSeparator>
                          <TimelineDot sx={{ backgroundColor: "#ffffff" }}>
                            {personalCheck !== "2" ? (
                              <CheckCircleIcon
                                color="success"
                                sx={{ fontSize: 20 }}
                              />
                            ) : (
                              <CancelIcon color="error" sx={{ fontSize: 20 }} />
                            )}
                          </TimelineDot>
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ padding: 1 }}>
                          {personalCheck !== "2" ? (
                            <Grid
                              container
                              direction="row"
                              sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Grid item>
                                <Typography variant="body2">
                                  ลำดับที่ 2 : นายสวัสดี วันจันทร์{" "}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#969696" }}
                                >
                                  19 วินาที
                                </Typography>
                              </Grid>

                              <Grid item sx={{ height: "100%" }}>
                                <Grid container direction="column">
                                  <Grid
                                    item
                                    sx={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        height: "25px",
                                      }}
                                      icon={
                                        <CheckCircleIcon
                                          sx={{ fontSize: 16 }}
                                        />
                                      }
                                      label="อนุมัติแล้ว"
                                      color="success"
                                    />
                                  </Grid>
                                  <Grid item>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#969696" }}
                                    >
                                      30/01/2568 01:23:58
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              container
                              direction="row"
                              sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Grid item>
                                <Typography variant="body2">
                                  ลำดับที่ 2 : นายสวัสดี วันจันทร์{" "}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#969696" }}
                                >
                                  19 วินาที
                                </Typography>
                              </Grid>

                              <Grid item sx={{ height: "100%" }}>
                                <Grid container direction="column">
                                  <Grid
                                    item
                                    sx={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        height: "25px",
                                      }}
                                      icon={
                                        <CancelIcon sx={{ fontSize: 16 }} />
                                      }
                                      label="ปฏิเสธ"
                                      color="error"
                                    />
                                  </Grid>
                                  <Grid item>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#969696" }}
                                    >
                                      30/01/2568 01:23:58
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </TimelineContent>
                      </TimelineItem>
                      <TimelineItem>
                        <TimelineSeparator>
                          {personalCheck !== "2" ? (
                            <TimelineDot sx={{ backgroundColor: "#ffffff" }}>
                              <CheckCircleIcon
                                color="success"
                                sx={{ fontSize: 20 }}
                              />
                            </TimelineDot>
                          ) : (
                            <TimelineDot sx={{ backgroundColor: "#ffffff" }}>
                              <RemoveIcon
                                sx={{
                                  fontSize: 19,
                                  color: "ffffff",
                                  backgroundColor: "#C8C8C8",
                                  borderRadius: 10,
                                }}
                              />
                            </TimelineDot>
                          )}
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ padding: 1 }}>
                          {personalCheck !== "2" ? (
                            <Grid
                              container
                              direction="row"
                              sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Grid item>
                                <Typography variant="body2">
                                  ลำดับที่ 3 : นายสวัสดี วันจันทร์{" "}
                                </Typography>
                              </Grid>
                              <Grid item sx={{ height: "100%" }}>
                                <Grid container direction="column">
                                  <Grid
                                    item
                                    sx={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        height: "25px",
                                      }}
                                      icon={
                                        <CheckCircleIcon
                                          sx={{ fontSize: 16 }}
                                        />
                                      }
                                      label="อนุมัติแล้ว"
                                      color="success"
                                    />
                                  </Grid>
                                  <Grid item>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#969696" }}
                                    >
                                      30/01/2568 01:23:58
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              container
                              direction="row"
                              sx={{
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid item>
                                <Typography variant="body2">
                                  ลำดับที่ 3 -
                                </Typography>
                              </Grid>
                              <Grid item sx={{ height: "100%" }}>
                                <Grid container direction="column">
                                  <Grid
                                    item
                                    sx={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        height: "25px",
                                        fontSize: 16,
                                        color: "#C8C8C8",
                                      }}
                                      label={
                                        <span style={{ color: "#ffffff" }}>
                                          -
                                        </span>
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </TimelineContent>
                      </TimelineItem> */}
                      {/* <TimelineItem>
                        <TimelineSeparator>
                          {personalCheck !== "2" ? (
                            <TimelineDot sx={{ backgroundColor: "#ffffff" }}>
                              <img
                                src={icon_time}
                                alt="รูปภาพ"
                                style={{
                                  width: "20px",
                                  height: "auto",
                                }}
                              />
                            </TimelineDot>
                          ) : (
                            <TimelineDot sx={{ backgroundColor: "#ffffff" }}>
                              <RemoveIcon
                                sx={{
                                  fontSize: 19,
                                  color: "ffffff",
                                  backgroundColor: "#C8C8C8",
                                  borderRadius: 10,
                                }}
                              />
                            </TimelineDot>
                          )}
                        </TimelineSeparator>
                        <TimelineContent sx={{ padding: 1 }}>
                          {personalCheck !== "2" ? (
                            <Grid
                              container
                              direction="row"
                              sx={{
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Grid item>
                                <Typography
                                  variant="body2"
                                  sx={{ fontSize: 12.4 }}
                                >
                                  {personalCheck === "3"
                                    ? "ลำดับที่ 4  : ผู้มีสิทธิ์อนุมัติ (กระทรวงสาธารณสุข)"
                                    : "ลำดับที่ 4 : นายสวัสดี  วันจันทร์"}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#969696" }}
                                >
                                  {personalCheck === "3" ? "" : "19 วินาที"}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Chip
                                  icon={
                                    <AccessAlarmIcon sx={{ fontSize: 15 }} />
                                  }
                                  label={
                                    <span
                                      style={{ color: "#ffffff", fontSize: 12 }}
                                    >
                                      รออนุมัติ
                                    </span>
                                  }
                                  sx={{
                                    backgroundColor: "#FFC048",
                                    color: "#ffffff",
                                    "& .MuiChip-icon": { color: "#ffffff" },
                                    height: "25px",
                                  }}
                                />
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              container
                              direction="row"
                              sx={{
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid item>
                                <Typography variant="body2">
                                  ลำดับที่ 4 -
                                </Typography>
                              </Grid>
                              <Grid item sx={{ height: "100%" }}>
                                {" "}
                               
                                <Grid container direction="column">
                                  <Grid
                                    item
                                    sx={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Chip
                                      sx={{
                                        height: "25px",
                                        fontSize: 16,
                                        color: "#C8C8C8",
                                      }}
                                      label={
                                        <span style={{ color: "#ffffff" }}>
                                          -
                                        </span>
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                          {personalCheck === "3" ? (
                            <Autocomplete
                              sx={{
                                mt: 2,
                                width: "100%",
                                "& .MuiInputBase-root": {
                                  height: "40px",
                                },
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "30px",
                                  backgroundColor: "#fff",
                                },
                              }}
                              open={openAutocomplete}
                              onOpen={() => setOpenAutocomplete(true)}
                              onClose={() => setOpenAutocomplete(false)}
                              isOptionEqualToValue={(option, value) =>
                                option.title === value.title
                              }
                              getOptionLabel={(option) => option.title}
                              options={options}
                              loadingText="กำลังค้นหา..."
                              loading={loadingAutocomplete}
                              inputValue={approverAutocomplete}
                              placeholder="เลือกผู้มีสิทธิ์อนุมัติ"
                              onInputChange={(_, newInputValue) =>
                                setApproverAutocomplete(newInputValue)
                              }
                              noOptionsText={
                                approverAutocomplete
                                  ? `"${approverAutocomplete}" ไม่พบข้อมูล`
                                  : "ไม่มีข้อมูล"
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="เลือกผู้มีสิทธิ์อนุมัติ"
                                  InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "green", // Default border color
                                      },
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "darkred", // Hover border color
                                      },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#0288D1 !important", // Focus border color
                                      },
                                    },
                                    endAdornment: (
                                      <>
                                        {loadingAutocomplete ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                            />
                          ) : (
                            ""
                          )}
                        </TimelineContent>
                      </TimelineItem> */}
                    </Timeline>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
            <TabPanel value="2">
              <Grid container sx={{ mt: 2 }}>
                <Grid item xs={12}>
                  <List
                    sx={{
                      width: "100%",
                      position: "relative",
                      overflow: "auto",
                      maxHeight: 300,
                      "& ul": { padding: 0 },
                      backgroundColor: "#ffffff",
                      border: "1px solid #DFEBF6",
                      borderRadius: 2,
                    }}
                  >
                    <li style={{ marginBottom: "16px", paddingTop: "0px" }}>
                      <ul>
                        {Array.isArray(resultComment) &&
                          resultComment.length > 0 ? (
                          resultComment.map((item: any, index: any) => (
                            <ListItem key={index}>
                              <ListItem
                                disablePadding
                                sx={{
                                  backgroundColor: "#E8F9FE",
                                  borderRadius: 2,
                                }}
                              >
                                <ListItemButton>
                                  <Grid
                                    container
                                    direction="row"
                                    sx={{
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Grid item>
                                      <ListItemIcon>
                                        <Grid
                                          container
                                          alignItems="center"
                                          spacing={1}
                                        >
                                          {" "}
                                          <Grid item>
                                            <Avatar>
                                              {item.name?.charAt(0)}
                                            </Avatar>
                                          </Grid>
                                          <Grid item>
                                            <ListItemText
                                              primary={`${typeof item === "object"
                                                  ? item?.name
                                                  : item.name
                                                }`}
                                            />
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                color: "#000000",
                                                display: "block",
                                                wordBreak: "break-word",
                                              }}
                                            >
                                              {typeof item === "object"
                                                ? item?.comment
                                                : item.comment}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </ListItemIcon>
                                    </Grid>
                                    <Grid item>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: "#5c6466" }}
                                      >
                                        {typeof item === "object"
                                           ? (() => {
                                            const date = new Date(
                                              item.update_time
                                            );
                                            if (isNaN(date.getTime()))
                                              return "-";

                                            const year = date.getFullYear();
                                            const buddhistYear = year + 543;
                                            const day = date
                                              .getDate()
                                              .toString()
                                              .padStart(2, "0");
                                            const month = (date.getMonth() + 1)
                                              .toString()
                                              .padStart(2, "0");

                                            const hours = date
                                              .getHours()
                                              .toString()
                                              .padStart(2, "0");
                                            const minutes = date
                                              .getMinutes()
                                              .toString()
                                              .padStart(2, "0");
                                            const seconds = date
                                              .getSeconds()
                                              .toString()
                                              .padStart(2, "0");

                                            return `${day}/${month}/${buddhistYear} ${hours}:${minutes}:${seconds}`;
                                          })()
                                        : "-"}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </ListItemButton>
                              </ListItem>
                            </ListItem>
                          ))
                        ) : (
                          <Grid
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                              flexDirection: "column",
                            }}
                          >
                            <img
                              src={no_data}
                              alt="no_data"
                              style={{
                                width: 65,
                                height: "auto",
                              }}
                            />
                            <Typography>ไม่มีข้อมูล</Typography>
                          </Grid>
                        )}

                        {/* {resultComment.map((item: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined) => (
                          <div> {typeof item === "object" ? JSON.stringify(item) : item}</div>
                        ))} */}
                      </ul>
                    </li>
                  </List>
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value="3">
              <LoadingIndicator open={loading} />
              <Grid container sx={{ mt: 2 }}>
                <Grid item xs={12}>
                  <List
                    sx={{
                      width: "100%",
                      position: "relative",
                      overflow: "auto",
                      maxHeight: 300,
                      "& ul": { padding: 0 },
                      backgroundColor: "#ffffff",
                      border: "1px solid #DFEBF6",
                      borderRadius: 2,
                    }}
                  >
                    <li style={{ marginBottom: "16px", paddingTop: "0px" }}>
                      <ul>
                        {Array.isArray(resultDetail?.attachment) &&
                          resultDetail.attachment.length > 0 ? (
                          resultDetail.attachment.map(
                            (item: IPDFFile, index: number) => (
                              <ListItem key={index}>
                                <ListItem
                                  disablePadding
                                  sx={{
                                    backgroundColor: "#E8F9FE",
                                    borderRadius: 2,
                                  }}
                                  secondaryAction={
                                    <Avatar
                                      sx={{
                                        bgcolor: "#FFFFFF",
                                        width: 70,
                                        height: 35,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: 3,
                                      }}
                                    >
                                     <Tooltip title="ดูเอกสาร PDF" placement="top">
                                      <IconButton
                                        sx={{ p: 0.5 ,marginRight: 0.5}}
                                        onClick={() => handleOpen(item)}
                                      >
                                        <RemoveRedEyeIcon
                                          sx={{
                                            color: "#2F4491",
                                            fontSize: 20,
                                          }}
                                        />
                                      </IconButton>
                                      </Tooltip>
                                      <Tooltip title="ดาวน์โหลด PDF" placement="top">
                                      <IconButton
                                        sx={{ p: 0.5 }}
                                        onClick={() => handleDownloadList(item)}
                                      >
                                        <SaveAltIcon
                                          sx={{
                                            color: "#2F4491",
                                            fontSize: 20,
                                          }}
                                        />
                                      </IconButton>
                                      </Tooltip>
                                    </Avatar>

                                    
                                  }
                                >
                                  <ListItemButton>
                                    <Grid
                                      container
                                      direction="row"
                                      sx={{
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid item>
                                        <ListItemIcon>
                                          <Grid
                                            container
                                            alignItems="center"
                                            spacing={1}
                                          >
                                            <Grid item>
                                              <img
                                                src={icon_pdf}
                                                alt="รูปภาพ"
                                                style={{
                                                  width: "38px",
                                                  height: "auto",
                                                }}
                                              />
                                            </Grid>
                                            <Grid item>
                                              <ListItemText
                                                sx={{ color: "#000000" }}
                                                primary={`${item.file_name}`}
                                              />
                                            </Grid>
                                          </Grid>
                                        </ListItemIcon>
                                      </Grid>
                                    </Grid>
                                  </ListItemButton>
                                </ListItem>
                              </ListItem>
                            )
                          )
                        ) : (
                          <Grid
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                              flexDirection: "column",
                            }}
                          >
                            <img
                              src={no_data}
                              alt="no_data"
                              style={{
                                width: "65px",
                                height: "65px",
                              }}
                            />
                            <Typography>ไม่มีข้อมูล</Typography>
                          </Grid>
                        )}
                      </ul>
                    </li>
                  </List>
                </Grid>
              </Grid>
            </TabPanel>

            {/* {String(checkPriorityButton())} */}
            {/* {String(checkReject)} */}

            {checkPriorityButton() &&  !checkReject ? (
            <Grid container justifyContent={"center"} gap={1} mt={2}>
              {resultDetail.priority === "3" && resultDetail.status_user === "waiting" ? 
                  <Button
                  onClick={handleEditDoc}
                  sx={{
                    width: { xs: "130px", lg: "100px" },
                    backgroundColor: "#FFC048",
                    color: "#ffffff",
                    border: "1px solid #FFC048",
                    borderRadius: 2,
                    "&:hover": {
                      backgroundColor: "#FFC048",
                    },
                  }}
                >
                  แก้ไขเอกสาร
                </Button> :""}
          
              <Button
                onClick={handleOpenRejectModal}
                sx={{
                  width: { xs: "130px", lg: "150px" },
                  backgroundColor: "#fff",
                  color: "#0288D1",
                  border: "1px solid #0288D1",
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "#E1E1E1",
                  },
                }}
              >
                ปฏิเสธลงนาม
              </Button>

              <ThirdPendingSignatureModal
                getSignatureByProviderTwo={getSignatureByProviderTwo}
                docNumber={docNumber}
                setDocNumber={setDocNumber}
                handleOpenSignModal={handleOpenSignModal}
                personalCheck={resultDetail.priority}
                approvePriority={resultDetail?.approve_list}
                approverAutocomplete={approverAutocomplete}
                setopenSignModal={setOpenSignModal}
              />
              {/* <Button
                  sx={{
                    backgroundColor: "#0288D1",
                    color: "#fff",
                    borderRadius: 2,
                    "&:hover": {
                      backgroundColor: "#0277BD",
                    },
                    pl: 2,
                    pr: 2,
                  }}
                  onClick={() => {
                    if (resultDetail.priority === "3") {
                      // handleOpenThirdSignatureModal();
                    } else if (["2", "4"].includes(resultDetail.priority)) {
                      handleOpenSignModal();
                    }
                  }}
                >
                  {resultDetail.priority === "3" || resultDetail.priority === "4"
                    ? "บันทึกข้อมูล และลงนามลายเซ็นดิจิทัล"
                    : "ลงนามลายเซ็นดิจิทัล xxxx"}
                </Button> */}
              {/* ✅ แสดง Modalเลือกอย่างใดอย่างหนึ่ง */}
              {/* {["2", "4"].includes(personalCheck) && (
                  <SignModal open={openSignModal} onClose={handleCloseSignModal} onSign={handleSign} />
                // <DrawSignatureModal open={openSignModal} onClose={handleCloseSignModal} onSign={handleSign} />
                )} */}

              {/* {openThirdSignatureModal && personalCheck === "3" && (
                  <ThirdPendingSignatureModal />
                )}
                 */}

              {/* ✅ เช็คเงื่อนไขการแสดง Modal */}
              {["1", "2", "3", "4"].includes(resultDetail.priority) && (
                <>
                  {hasSignatureFromProvider ? (
                    <SignModal
                      // open={openSignModal && hasSignatureFromProvider}
                      open={openSignModal}
                      onClose={handleCloseSignModal}
                      onSign={handleSign}
                    />
                  ) : (
                    <DrawSignatureModal
                      arrrayOfPdf={arrrayOfPdf}
                      docNumber={docNumber}
                      approverAutocomplet={approverAutocomplete!}
                      localStorageOrganization={localStorageOrganization}
                      localStorageData={localStorageData}
                      setLoading={setLoading}
                      dataPageForm={resultDetail}
                      open={openSignModal}
                      // open={openSignModal && !hasSignatureFromProvider}
                      onClose={handleCloseSignModal}
                      onSign={handleSign}
                      getBase64OfSign={getBase64OfSign}
                    />
                  )}
                </>
              )}

              {/* เรียกใช้ Modal สำหรับการปฏิเสธลงนาม */}
              <RejectSignatureDialog
                setLoading={setLoading}
                resultDetail={resultDetail}
                open={openRejectModal}
                onClose={handleCloseRejectModal}
                onReject={(reason) => {
                  console.log("เหตุผลที่ปฏิเสธ:", reason);
                }}
              />
            </Grid>
           ) : (
              ""
            )} 
          </TabContext>

          {/* </Grid> */}
        </Grid>
      </Grid>
      <ModalPreviewPDF
        base64PDF={base64PDF}
        setBase64PDF={setBase64PDF}
        openPDF={openPDF}
        setOpenPDF={setOpenPDF}
      />
    </Grid>
  );
};

export default DetailDocPending;
